// LocContext.JOB
// prettier-ignore
export default {
  // localization/cleanAndTranslatePositionForm.tsx
  "6fedf369ddcd": "Fast stilling",
  "9f515796226b": "Engasjement",

  // business-components/applicationSent/index.tsx
  "c0f47f3c27b4": "Ledige stillinger",
  "842aefee5e56": "Søk på stilling",
  "f14631b913c2": "Tusen takk for søknaden!",
  "28588d2bb196": "Du har søkt på stillingen “{1}”. Du hører fra oss snart!",
  "cb2eaf126483": "I mellomtiden kan du logge inn i vår CV Portal, her kan du registere din CV, se og søke på flere stillinger.",
  "db2831a8e6c5": "Logg inn i CV Portalen",
  "d72e876a8b1e": "Lukk",
  "2c3002205796": "Gå til min profil",
  "e4b4b4136886": "Lukk",
  "fdfb2c2ad4e5": "I mellomtiden kan du opprette en profil i vår CV Portal, her kan du registere din CV, se og søke på flere stillinger.",
  "34ca0ef1eea5": "Opprett profil",
  "f7c2e9f429f2": "Lukk",

  // business-components/applicationSent/MissingInfo.tsx
  "da2359a945d7": "Vi mangler viktig informasjon om deg",
  "5290613cff10": "Registrer informasjon",

  // business-components/jobView/JobViewBase.tsx
  "9ebb1868d4cc": "Søk på stilling",
  "babb4d5358d4": "Stillingsoversikt",
  "d68c43f0ccae": "Om oss",
  "e0e46022a793": "Om arbeidsgiveren",
  "1b8d4414f2c9": "Om stillingen",
  "c9ea0daebc8e": "Første dag",
  "4a373b0e2c7f": "Du har søkt på denne stillingen",
  "a6b778d051fd": "Slett søknad",
  "dbf89dfd4d8b": "Søk på stilling",
  "f26bee0a9c89": "Søknadsfrist",
  "9dd9b47a2d17": "Antall stillinger",
  "9ace16b1427a": "Stillingstype",
  "5c5d2a5162af": "Stillingsform",
  "5821910fc160": "Arbeidssted",
  "bc874bb16f26": "Kommune",
  "9fad28e7bf06": "Kommune",
  "e647d03212d0": "Fylke",
  "b29e44a639ae": "Refnr",
  "13b0e27c5a37": "Publisert dato",
  "4883d7bee3ca": "Del jobben:",
  "f36d708f5466": "Del på facebook",
  "37969f1e149c": "Del på linkedIn",
  "5ebd1f07e518": "Del på twitter",
  "fd7cfef428ff": "Kontaktpersoner",
  "0d7cdef488fa": "Kontaktperson",
  "ac9532e1d8cf": "{0} avd. {1}",

  // business-components/forms/applyWithoutProfile/ApplyManuallyWithoutProfileForm.tsx
  "37612e2ebb06": "Fyll ut og søk med Connect",
  "61b1f1bb0315": "Eller",
  "c83a64de2b41": "Fornavn",
  "8ebf9042002b": "Etternavn",
  "d1b9c5a0a1e6": "E-post",
  "f00ab2ca26a9": "Telefon",
  "ad066b68e31a": "Adresse",
  "3033940f55f7": "Postnummer",
  "a4c5c6e2b140": "Fødselsdato",
  "5b3e7c7fcabe": "Jeg forstår og aksepterer teksten ovenfor",
  "06450f619276": "Tilbake",
  "fb67618c60b0": "Send søknad",

  // business-components/forms/applyWithoutProfile/ApplyWithNameForm.tsx
  "760d88cf6820": "Avbryte søknad",
  "f109a251442c": "Er du sikker på at du vil avbryte søknaden? Du vil miste all informasjon du har skrevet inn.",
  "2ac00f863b1a": "Fornavn",
  "ecf0b4c0a812": "Etternavn",
  "e53d78c30ff1": "Avbryt",
  "acafabcce0ae": "Send søknad",

  // business-components/forms/applyWithoutProfile/ApplyWithoutProfileConsentForm.tsx
  "b67b421645ed": "Skriv en kort søknadstekst (maks {1} tegn)",
  "c00533793914": "Last opp vedlegg",
  "90d3f125e34a": "Valgte vedlegg:",
  "15ed806512b8": "Jeg forstår og aksepterer teksten ovenfor",
  "2caeebacac88": "Tilbake",
  "f5afd7e67617": "Fyll ut og søk med Connect",
  "7a44726ee965": "Fyll ut og søk med skjema",

  // business-components/forms/applyWithoutProfile/ApplyWithoutProfileForm.tsx
  "3a2d1f7c2c01": "Fornavn",
  "37bc2d79a757": "Etternavn",
  "bdf9e468dd80": "E-post",
  "bb3beb895ddc": "Telefon",
  "c30f9b357d50": "Søknadstekst",
  "dd333d10ede5": "Jeg ønsker å laste opp vedlegg",
  "28952e50450b": "Valgte vedlegg:",
  "d3c4c7a2b3c3": "Jeg forstår og aksepterer teksten ovenfor",
  "c7286cf712e7": "Avbryt",
  "51d4658b9718": "Send søknad",

  // business-components/forms/applyWithProfile/ApplyWithProfileForm.tsx
  "98eb22359a21": "Last opp vedlegg",
  "166f7bdcfdb9": "Valgte vedlegg:",
  "1181d314d16e": "Jeg forstår og aksepterer teksten ovenfor",
  "a9838122fbaa": "Avbryt",
  "dc57f6a76115": "Send søknad",
}